module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navigation"
  }, [_c('ul', {
    staticClass: "navigation--inner"
  }, [_c('router-link', {
    staticClass: "navigation--item",
    attrs: {
      "to": "/schedule",
      "active-class": "active",
      "tag": "li"
    }
  }, [_c('a', {
    staticClass: "navigation--link"
  }, [_c('svg', {
    staticClass: "navigation--icon",
    attrs: {
      "height": "16",
      "viewbox": "0 0 16 16",
      "width": "16",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15 2h-2V1c0-.6-.4-1-1-1h-1c-.6 0-1 .4-1 1v1H6V1c0-.6-.4-1-1-1H4c-.6 0-1 .4-1 1v1H1c-.6 0-1 .4-1 1v12c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1zm-1 12H2V7h12v7z",
      "fill-rule": "nonzero"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "navigation--text"
  }, [_vm._v("\n                  Scheduled Videos\n              ")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "navigation--item",
    attrs: {
      "to": "/pending",
      "active-class": "active",
      "tag": "li"
    }
  }, [_c('a', {
    staticClass: "navigation--link"
  }, [_c('svg', {
    staticClass: "navigation--icon",
    attrs: {
      "height": "16",
      "width": "16 ",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 50 50"
    }
  }, [_c('path', {
    attrs: {
      "d": "M25 0C11.214844 0 0 11.214844 0 25s11.214844 25 25 25 25-11.214844 25-25S38.785156 0 25 0zm1.796875 36.933594c0 .214844-.144531.359375-.359375.359375h-2.722656c-.21875 0-.359375-.144531-.359375-.359375v-3.082031c0-.214844.140625-.359375.359375-.359375H26.4375c.214844 0 .359375.144531.359375.359375zm3.15625-13.664063l-2.402344 3.300782c-.71875.96875-.933593 1.46875-.933593 2.691406v1.144531c0 .214844-.144532.359375-.359375.359375h-2.367188c-.214844 0-.355469-.144531-.355469-.359375V28.9375c0-1.433594.320313-2.1875 1.074219-3.226562l2.402344-3.300782c1.253906-1.722656 1.683594-2.546875 1.683594-3.765625 0-2.046875-1.433594-3.335937-3.476563-3.335937-2.007812 0-3.300781 1.21875-3.730469 3.40625-.035156.214844-.179687.324219-.394531.289062l-2.257812-.398437c-.214844-.035156-.324219-.175781-.289063-.394531.539063-3.441407 3.015625-5.703125 6.746094-5.703125 3.871094 0 6.488281 2.546875 6.488281 6.097656 0 1.722656-.609375 2.980469-1.828125 4.664062z"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "navigation--text"
  }, [_vm._v("\n                Pending Videos\n            ")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "navigation--item",
    attrs: {
      "to": "/history",
      "active-class": "active",
      "tag": "li"
    }
  }, [_c('a', {
    staticClass: "navigation--link"
  }, [_c('svg', {
    staticClass: "navigation--icon",
    attrs: {
      "height": "16",
      "viewbox": "0 0 16 16",
      "width": "16",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm4 9H7V4h2v3h3v2z",
      "fill-rule": "nonzero"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "navigation--text"
  }, [_vm._v("\n                History\n            ")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "navigation--item navigation--item_divider",
    attrs: {
      "to": "/blocked",
      "active-class": "active",
      "tag": "li"
    }
  }, [_c('a', {
    staticClass: "navigation--link"
  }, [_c('svg', {
    staticClass: "navigation--icon",
    attrs: {
      "height": "16",
      "viewbox": "0 0 16 16",
      "width": "16",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 2c1.3 0 2.5.4 3.5 1.1l-8.4 8.4C2.4 10.5 2 9.3 2 8c0-3.3 2.7-6 6-6zm0 12c-1.3 0-2.5-.4-3.5-1.1l8.4-8.4c.7 1 1.1 2.2 1.1 3.5 0 3.3-2.7 6-6 6z",
      "fill-rule": "nonzero"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "navigation--text"
  }, [_vm._v("\n                Blocked\n            ")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "navigation--item",
    attrs: {
      "to": "/cities",
      "active-class": "active",
      "tag": "li"
    }
  }, [_c('a', {
    staticClass: "navigation--link"
  }, [_c('svg', {
    staticClass: "navigation--icon",
    attrs: {
      "height": "16",
      "viewbox": "0 0 16 16",
      "width": "16",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15 9h-2V3c0-.6-.4-1-1-1H9V0H7v2H4c-.6 0-1 .4-1 1v6H1c-.6 0-1 .4-1 1v5c0 .6.4 1 1 1h14c.6 0 1-.4 1-1v-5c0-.6-.4-1-1-1zM5 10V4h6v10H9v-3H7v3H5v-4z"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "navigation--text"
  }, [_vm._v("\n                Cities\n            ")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "navigation--item",
    attrs: {
      "to": "/walls",
      "active-class": "active",
      "tag": "li"
    }
  }, [_c('a', {
    staticClass: "navigation--link"
  }, [_c('svg', {
    staticClass: "navigation--icon",
    attrs: {
      "height": "16",
      "viewbox": "0 0 16 16",
      "width": "16",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3 14h10v2H3zM15 12H1c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1h14c.6 0 1 .4 1 1v10c0 .6-.4 1-1 1zM2 10h12V2H2v8z"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "navigation--text"
  }, [_vm._v("\n                Walls\n            ")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "navigation--item",
    attrs: {
      "to": "/partners",
      "active-class": "active",
      "tag": "li"
    }
  }, [_c('a', {
    staticClass: "navigation--link"
  }, [_c('svg', {
    staticClass: "navigation--icon",
    attrs: {
      "height": "16",
      "viewbox": "0 0 14 16",
      "width": "14",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11.8 14l-1.6-6.6 2.4-1.6c.2-.2.4-.5.4-.8V0h-2v2H8V0H6v2H3V0H1v5c0 .3.2.6.4.8l2.4 1.6L2.2 14H0v2h14v-2h-2.2z",
      "fill-rule": "nonzero"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "navigation--text"
  }, [_vm._v("\n                Partners\n            ")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "navigation--item",
    attrs: {
      "to": "/featured",
      "active-class": "active",
      "tag": "li"
    }
  }, [_c('a', {
    staticClass: "navigation--link"
  }, [_c('svg', {
    staticClass: "navigation--icon",
    attrs: {
      "height": "16",
      "viewbox": "0 0 16 16",
      "width": "16",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15.144 5.438l-4.316-.627L8.898.9C8.557.217 7.44.217 7.102.9l-1.93 3.91-4.317.628C.04 5.558-.292 6.565.302 7.145l3.124 3.044-.737 4.298c-.14.814.716 1.44 1.45 1.054L8 13.512l3.86 2.03c.73.382 1.592-.233 1.452-1.053l-.737-4.3L15.7 7.146c.592-.58.26-1.59-.556-1.708z",
      "fill-rule": "nonzero"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "navigation--text"
  }, [_vm._v("\n                Featured\n            ")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "navigation--item",
    attrs: {
      "to": "/screensavers",
      "active-class": "active",
      "tag": "li"
    }
  }, [_c('a', {
    staticClass: "navigation--link"
  }, [_c('svg', {
    staticClass: "navigation--icon",
    attrs: {
      "height": "16",
      "viewbox": "0 0 16 16",
      "width": "16",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15 0H1C.448 0 0 .448 0 1v14c0 .552.448 1 1 1h14c.552 0 1-.448 1-1V1c0-.552-.448-1-1-1zm-1 14H8V9c0-.552-.448-1-1-1H2V2h12v12z",
      "fill-rule": "nonzero"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "navigation--text"
  }, [_vm._v("\n                Screensavers\n            ")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "navigation--item navigation--item_divider",
    attrs: {
      "to": "/notifications",
      "active-class": "active",
      "tag": "li"
    }
  }, [_c('a', {
    staticClass: "navigation--link"
  }, [_c('svg', {
    staticClass: "navigation--icon",
    attrs: {
      "height": "15",
      "viewbox": "0 0 16 15",
      "width": "16",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14.7 0L.7 4c-.4.2-.7.6-.7 1v4c0 .4.3.8.7 1l1.3.3V14c0 .6.4 1 1 1h5c.6 0 1-.4 1-1v-1.7l5.7 1.6c.6.2 1.3-.3 1.3-1V1c0-.7-.6-1.1-1.3-1zM7 13H4v-2.1l3 .9V13z",
      "fill-rule": "nonzero"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "navigation--text"
  }, [_vm._v("\n                Notifications\n            ")])])]), _vm._v(" "), _c('li', {
    staticClass: "navigation--item",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_c('a', {
    staticClass: "navigation--link",
    attrs: {
      "href": "#"
    }
  }, [_c('svg', {
    staticClass: "navigation--icon",
    attrs: {
      "height": "16",
      "viewbox": "0 0 15 16",
      "width": "15",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "fill": "#A4B0C2",
      "fill-rule": "nonzero"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10 12.414L14.414 8 10 3.586 8.586 5l2 2H4v2h6.586l-2 2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11 14H2V2h9V0H1C.448 0 0 .448 0 1v14c0 .552.448 1 1 1h10v-2z"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "navigation--text"
  }, [_vm._v("\n                    Sign Out\n                ")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "navigation--clickstop"
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9befec38", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9befec38","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Menu.vue
// module id = 455
// module chunks = 1